module.exports = __webpack_public_path__ + "f513ac3efe27564657bc4e3a2b2bdee5.pdf";